import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { getPostLoginRoute, syncUserWithBackend } from './auth';

const AuthRedirect = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

useEffect(() => {
  const account = instance.getActiveAccount() || instance.getAllAccounts()[0];
  if (account) {
    instance.setActiveAccount(account);
    (async () => {
      try {
        const userData = await syncUserWithBackend(instance); // Await this
        navigate(getPostLoginRoute(userData?.rolename || userData?.userRole || userData?.roleName));
      } catch (err) {
        console.error("Error syncing user:", err);
        navigate('/');
      }
    })();
  } else {
    // console.warn("No account found after redirect.");
    navigate('/');
  }
}, [instance, navigate]);





  return null;
};

export default AuthRedirect;
